import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@fortawesome/fontawesome-free/svgs/solid/bars.svg'
import _imports_1 from '@fortawesome/fontawesome-free/svgs/solid/trash-can.svg'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "card__title" }, "Settings", -1)
const _hoisted_3 = { class: "locations__location" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon icon_small draggable-handle",
  alt: "Close Settings"
}, null, -1)
const _hoisted_5 = { class: "locations__name" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon icon_small",
  alt: "Close Settings"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "card__title" }, "Add Location:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!
  const _component_add_location = _resolveComponent("add-location")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_draggable, {
      modelValue: _ctx.draggableLocations,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draggableLocations) = $event)),
      onStart: _ctx.onDragStart,
      onEnd: _ctx.onDragEnd,
      "item-key": "name",
      class: "locations",
      handle: ".draggable-handle"
    }, {
      item: _withCtx(({ element }) => [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, _toDisplayString(element.name), 1),
          _createElementVNode("button", {
            class: "locations__remove-button",
            onClick: ($event: any) => (_ctx.remove(element))
          }, _hoisted_8, 8, _hoisted_6)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onStart", "onEnd"]),
    (_ctx.locations.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, " No locations added. Please enter the city name in the field below. "))
      : _createCommentVNode("", true),
    _hoisted_10,
    _createVNode(_component_add_location, {
      onSelected: _cache[1] || (_cache[1] = (city) => _ctx.add(city)),
      onError: _cache[2] || (_cache[2] = (e) => _ctx.error(e))
    })
  ]))
}